import React from "react";
import DashboardBaseComponent from "../bases/DashboardBaseComponent/DashboardBaseComponent";
export default function DashboardHome() {
  return (
    <div className="pp-page">
      <DashboardBaseComponent />
    </div>
  );
}
